import React, { useEffect, useState } from "react";
import Tabs from "../../../../Component/DigitalMarketing/Tabs";
import { Button } from "@mui/material";

const DashTabs = (props) => {
  const { show, setShow, setActiveIndex, setUpdateData,setTabName } = props;
  const [active, setActive] = useState(1);

  const values = [
    { id: 1, name: "Complaints" },
    { id: 2, name: "H&E" },
    { id: 3, name: "Advice" },
    { id: 4, name: "Diagnosis" },
  ];

  const activeTabName = values.find((item) => item.id === active)?.name || "";

  useEffect(() => {
    if (active) {
      setActiveIndex(active);
      setUpdateData([])
      setTabName(activeTabName)
    }
  }, [active]);
  return (
    <div className="row">
      <div className="col-9">
        <Tabs tablist={values} active={active} setActive={setActive} />
      </div>
      <div className="col-3 mt-2 d-flex justify-content-end">
        <div>
          {/* {PermissionCheck("medicine_master", "add") && ( */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              id="btn"
              style={{ padding: show ? "10px" : "10px" }}
              onClick={() => {
                setShow(!show);
                setUpdateData([])
                // setView(false)
              }}
            >
              {show ? `x  Close` : `+ Add ${activeTabName}`}
            </Button>
          </div>
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default DashTabs;
